import WelcomeJourney from "./WelcomeJourney";

export default WelcomeJourney;
